import React from 'react';
import { IdsIconsDefinition } from '@ids/react-icon';
import { useStateSelector } from 'store';
import { Render } from 'types';
import { WorkshopCheckbox } from './shared/WorkshopCheckbox';
import { WorkshopField } from './shared/WorkshopField';
import { WorkshopSection } from './shared/WorkshopSection';

export const WorkshopAdditionalInfo = (): Render => {
  const editing = useStateSelector((state) => state.workshop.editing);

  const Checkbox = WorkshopCheckbox(editing);
  const Field = WorkshopField(editing);
  const iconProps = { group: 'ui', size: 24, icon: 'cockade' } as IdsIconsDefinition;

  return (
    <WorkshopSection
      title='Additional'
      icon={iconProps}
      contentClass='additional-information-container'
      anchorTag='additional'
    >
      <Field property='maxHeight' label='Max height (mm)' />
      <Checkbox property='isIfCertified' label='If selected workshop' />
      <Checkbox property='isInsuranceRetailer' label='Sells insurance' />
      <Field property='towingEmail' label='Towing e-mail' />
      <Checkbox property='excludeForTowers' />
    </WorkshopSection>
  );
};
